import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators'
import Store from '@/store/index.ts'
import ExtensionModel from '@/models/extension/extensionModel.ts'
import { UrlType } from '@/constants/urlType.ts'
import ApiService from '@/services/apiService.ts'

@Module({ dynamic: true, store: Store, name: 'extension', namespaced: true })
export default class ExtensionModule extends VuexModule {
  private extension: ExtensionModel = new ExtensionModel()

  @Mutation
  public setExtension(extension: ExtensionModel): void {
    this.extension = extension
    localStorage.setItem('extension', JSON.stringify(extension))
  }

  @Action({ rawError: true, commit: 'setExtension' })
  public async fetchExtension(id: string): Promise<ExtensionModel> {
    return await ApiService.get<ExtensionModel>(UrlType.Extension, id)
  }

  get getExtension(): ExtensionModel {
    return this.extension
  }

  get getExtensionId(): string {
    return this.extension.extensionId
  }
}
